import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';

import {
  ILogoConfig,
  ILogoImageConfig,
  ILogoSvgConfig,
  LogoType,
} from './models/logo.interfaces';

import { AppConfigState } from '@nibtravel/shared/util/app-config';

import { Store } from '@ngxs/store';

function isLogoSvg(value: any): value is ILogoSvgConfig {
  return value?.type === LogoType.SVG;
}

function isLogoImage(value: any): value is ILogoImageConfig {
  return value?.type === LogoType.Image;
}

function isIcon(value: any): boolean {
  return typeof value === 'string';
}

/**
 * Presentational component responsible for rendering a logo
 */
@Component({
  selector: 'nibtravel-logo',
  templateUrl: './logo.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoComponent {
  @HostBinding('id') id = 'logo';
  @HostBinding('class') klass = 'logo';
  @Input() config!: ILogoConfig;

  logoType = LogoType;

  constructor(private store: Store) {}

  get configType(): LogoType | 'icon' | undefined {
    if (isIcon(this.config)) {
      return 'icon';
    }
    if (isLogoImage(this.config) || isLogoSvg(this.config)) {
      return this.config.type;
    }
    return undefined;
  }

  get logoConfig(): ILogoImageConfig | ILogoSvgConfig | undefined {
    return isLogoImage(this.config) || isLogoSvg(this.config)
      ? this.config
      : undefined;
  }

  get logoSvg(): ILogoSvgConfig | undefined {
    return isLogoSvg(this.config) ? this.config : undefined;
  }

  get logoImage(): ILogoImageConfig | undefined {
    return isLogoImage(this.config) ? this.config : undefined;
  }

  linkUrl() {
    return this.store.selectSnapshot(AppConfigState.getKosmosUrl);
  }
}
